import {Box, styled, ToggleButton, ToggleButtonGroup, Tooltip, Typography} from '@mui/material'
import moment from 'moment-timezone'
import {useTranslation} from 'react-i18next'

import {
  DOWNTIME_STATISTICS_TOGGLE_VIEWS,
  DowntimeStatisticsViewToggleOption,
  DowntimeStatisticsViewToggleOptions,
  FEATURE_NAMESPACE
} from '../consts'

const StyledToggleButton = styled(ToggleButton)(({theme}) => ({
  width: 'fit-content',
  borderRadius: theme.spacing(1),
  display: 'flex',
  color: theme.palette.text.secondary,
  '&.MuiToggleButtonGroup-grouped:not(.Mui-selected)': {
    border: 'none',
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },
  '&.Mui-selected': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      borderColor: theme.palette.primary.dark
    }
  }
}))

type ToggleButtonProps = {
  value: DowntimeStatisticsViewToggleOption
  onChange: (value: DowntimeStatisticsViewToggleOption) => void
  timezone: string
  isMobile?: boolean
}

export const DowntimeStatisticsYtmMtmToggleButton: React.FC<ToggleButtonProps> = ({
  value,
  onChange,
  timezone,
  isMobile
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const onValueChanged = (
    event: React.MouseEvent<HTMLElement>,
    kpiView: DowntimeStatisticsViewToggleOption
  ) => {
    if (kpiView) {
      onChange(kpiView)
    }
  }
  const lastDayOfPastMonth = moment.tz(timezone).subtract(1, 'month').endOf('month')
  const formatedMoment = moment(lastDayOfPastMonth, 'YYYY/MM/DD')
  const month = formatedMoment.format('MM')
  const day = formatedMoment.format('D')

  return (
    <Box sx={{display: 'flex'}}>
      <ToggleButtonGroup
        exclusive={true}
        value={value}
        onChange={onValueChanged}
        sx={(theme) => ({
          display: 'flex',
          border: `1px solid ${theme.palette.action.selected}`,
          height: theme.spacing(7),
          backgroundColor: theme.palette.action.selected
        })}
      >
        {DOWNTIME_STATISTICS_TOGGLE_VIEWS.map((kpiView) => (
          <StyledToggleButton
            key={kpiView}
            value={kpiView}
            data-test-id={`ytm-mtm-toggle-btn-${kpiView}`}
          >
            <Tooltip
              title={
                t(`actions.${kpiView}`) +
                ' ' +
                t(`label.tooltip.${kpiView}`) +
                `${kpiView === DowntimeStatisticsViewToggleOptions.YTM_VIEW ? '01' : month}.` +
                ' ' +
                `- ${day}.${month}.)`
              }
              arrow
              placement="bottom"
            >
              <Typography variant="h5">
                {isMobile ? t(`actions.${kpiView}_short`) : t(`actions.${kpiView}`)}
              </Typography>
            </Tooltip>
          </StyledToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  )
}
